import Vue from 'vue';
import Vuex from 'vuex';
import * as mutations from '../utils/mutation-types';
import { LicenseService } from '../services/license-service';
import { GLIM_TIMECODE_SOURCE } from '@/utils/constants';

import { annotations } from './annotations.store';
import { audio } from './audio.store';
import { clips } from './clips.store';
import { files } from './files.store';
import { history } from './history.store';
import { indexer } from './indexer.store';
import { license } from './license.store';
import { plugins } from './plugins.store';
import { quickview } from './quickview.store';
import { scopes } from './scopes.store';
import { snack } from './snack.store';
import { ui } from './ui.store';
import { user } from './user.store';
import { video } from './video.store';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    videoPath:         null,
    videoOpen:         false,
    showAlphaChannel:  false,
    showAudioMeters:   false,
    showFrameMetadata: false,
    showWaveform:      false,
    overlayFlags:      0,
    currentTimeCode:   {
      track: null,
      value: null,
    },
    timeDisplaySource:    GLIM_TIMECODE_SOURCE,
    videoCurrentTime:     0,
    videoDuration:        0,
    videoCurrentTimecode: null,
    experimentalFeatures: {
      scopes: false
    },
    isQuickView:              false,
    fps:                      0,
    frame:                    null,
    licenseService:           new LicenseService(),
    uiAccess:                 new Set(),
    fileTableSort:            { sortBy: 'name', sortDesc: false },
    videoController:          null,
    videoElement:             null,
    userSubtitles:            null,
    userStartFrame:           null,
    openItems:                [],
    activeItems:              [],
    fileBrowserFilterValues:  [],
    fileBrowserFilterType:    [],
    audioPathsConfig:         [],
    currentSidecarAudioPaths: null,
  },
  mutations: {
    [mutations.SET_EXPERIMENTAL_FEATURES](state, value) {
      state.experimentalFeatures = value;
    },
    [mutations.SET_VIDEO_PATH](state, value) {
      state.videoPath = value;
    },
    [mutations.SET_VIDEO_OPEN](state, value) {
      state.videoOpen = value;
    },
    [mutations.SET_CURRENT_AUDIO_TRACK_SOUNDFIELD](state, { soundfield, left, right }) {
      if (soundfield === 'Stereo') {
        state.currentAudioTrack.left = left;
        state.currentAudioTrack.right = right;
      }

      state.currentAudioTrack.currentSoundfield = soundfield;
    },
    [mutations.TOGGLE_AUDIO_METERS](state) {
      state.showAudioMeters = !state.showAudioMeters;
    },
    [mutations.TOGGLE_ALPHA_CHANNEL](state) {
      state.showAlphaChannel = !state.showAlphaChannel;
    },
    [mutations.TOGGLE_FRAME_METADATA](state) {
      state.showFrameMetadata = !state.showFrameMetadata;
    },
    [mutations.TOGGLE_WAVEFORM](state) {
      state.showWaveform = !state.showWaveform;
    },
    [mutations.SET_OVERLAY_FLAGS](state, value) {
      state.overlayFlags = value;
    },
    [mutations.SET_VIDEO_CURRENT_TIME](state, value) {
      state.videoCurrentTime = value;
    },
    [mutations.SET_VIDEO_DURATION](state, value) {
      state.videoDuration = value;
    },
    [mutations.SET_VIDEO_CURRENT_TIMECODE](state, value) {
      state.videoCurrentTimecode = value.timecode;
      state.frame = value.frame;
    },
    [mutations.SET_TIME_DISPLAY_SOURCE](state, source) {
      state.timeDisplaySource = source;
    },
    [mutations.SET_IS_QUICK_VIEW](state, value) {
      state.isQuickView = value;
    },
    [mutations.SET_FPS](state, value) {
      state.fps = value;
    },
    [mutations.SET_FRAME](state, value) {
      state.frame = value;
    },
    [mutations.SET_UI_ACCESS](state, value) {
      state.uiAccess = value;
    },
    [mutations.SET_FILE_TABLE_SORT](state, value) {
      state.fileTableSort = value;
    },
    [mutations.SET_VIDEO_CONTROLLER](state, value) {
      state.videoController = value;
    },
    [mutations.SET_VIDEO_ELEMENT](state, value) {
      state.videoElement = value;
    },
    [mutations.SET_USER_SUBTITLES](state, value) {
      state.userSubtitles = value;
    },
    [mutations.SET_USER_START_FRAME](state, value) {
      state.userStartFrame = value;
    },
    [mutations.SET_OPEN_ITEMS](state, value) {
      state.openItems = value;
    },
    [mutations.SET_ACTIVE_ITEMS](state, value) {
      state.activeItems = value;
    },
    [mutations.SET_FILE_BROWSER_FILTER_VALUES](state, value) {
      state.fileBrowserFilterValues = value;
    },
    [mutations.SET_FILE_BROWSER_FILTER_TYPE](state, value) {
      state.fileBrowserFilterType = value;
    },
    [mutations.SET_AUDIO_PATHS_CONFIG](state, value) {
      state.audioPathsConfig = value;
    },
    [mutations.SET_CURRENT_SIDECAR_AUDIO_PATHS](state, value) {
      state.currentSidecarAudioPaths = value;
    },
  },
  modules: {
    annotations: annotations,
    audio:       audio,
    clips:       clips,
    files:       files,
    history:     history,
    indexer:     indexer,
    license:     license,
    plugins:     plugins,
    quickview:   quickview,
    scopes:      scopes,
    snack:       snack,
    ui:          ui,
    user:        user,
    video:       video,
  },
});
